import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { Button, ButtonGroup } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import HeaderQuoteAi from './headerQuoteAi';
import SidebarQuoteAi from '../quote/sidebarQuoteAi';
import RightHeaderPage from './rightHeader';

const PolicyTermPage = () => {
  const navigate = useNavigate();
  const [selectedPolicyTerm, setSelectedPolicyTerm] = useState('');
  // Policy Term options
  const policyTerms = ['Select Policy Term', '6 Months', '12 Months', '24 Months', '36 Months'];

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />
        <div className="QuoteDashboard">
          <div className="main">
            <div className="pageformBloack">
              <div className=" container-fluid ">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sidebar-visible">
                      <SidebarQuoteAi />
                    </div>
                  </div>

                  <div className="col-12 col-md-12 col-lg-8 gx-2 main-quotescroll">
                    <div className="whiteBoxCont ">
                      <div className="quote_buttongroup">
                        <div className="form_action_buttons mb-2">
                          <ButtonGroup>
                            <Button
                              variant="outline-back"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/ContactInformationPage')}
                            >
                              Back
                            </Button>
                            <Button
                              variant="outline-next"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/LocationPage')}
                            >
                              Next
                            </Button>
                          </ButtonGroup>
                          <ButtonGroup>
                            <Button variant="outline-cancel" className="button-gap">
                              Cancel
                            </Button>
                            <Button variant="primary-save" className="button-gap">
                              Save
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="scrollable-content">
                        <div className="formcard-container mrgTop">
                          {/* Insured Information Section */}
                          <Card className="mb-4 formpage-card">
                            <Card.Header className="formpage-card-header">Policy Term</Card.Header>
                            <Card.Body>
                              <Row>
                                {/* Effective Date */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Effective Date</Form.Label>
                                    <Form.Control type="date" placeholder="Select Effective Date" />
                                  </Form.Group>
                                </Col>

                                {/* Policy Term */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Policy Term</Form.Label>
                                    <Form.Select
                                      value={selectedPolicyTerm}
                                      onChange={(e) => setSelectedPolicyTerm(e.target.value)}
                                    >
                                      {policyTerms.map((term, index) => (
                                        <option key={index} value={term}>
                                          {term}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                                </Col>

                                {/* Expiration Date */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Expiration Date</Form.Label>
                                    <Form.Control
                                      type="date"
                                      placeholder="Select Expiration Date"
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sticky-right-top">
                      <RightHeaderPage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PolicyTermPage;
